<template>
  <div class="ma-4">
    <div class="mb-3">
      <span class="main-title">SUMMARY | &nbsp;</span>
      <span class="submain-title">Hotel Order Report</span>
    </div>
    <SearchHotelService />
    <HotelOrderReport />
  </div>
</template>

<script>
import { mapState } from "vuex";
import SearchHotelService from "@/components/back-office/Report/SearchBar/SearchHotelService";
import HotelOrderReport from "@/components/back-office/Report/HotelOrderReport";
export default {
  data() {
    return {};
  },
  destroyed() {
    this.$store.commit("hotelReport/CLEAR_STATE");
  },
  computed: {
    ...mapState({}),
  },
  components: {
    SearchHotelService,
    HotelOrderReport,
  },
  methods: {},
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Hotel Order report",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/hotel-service/order-report",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
